import { APP_CONFIG } from "../../config";

import { AWSSDK } from "../../services/cloud";
import { TIME } from "../../services/util";

const { AWS_URL } = APP_CONFIG;

const { uploadS3 } = AWSSDK;

const { getCurrentDateFormat, getCurrentDateTimeFormat } = TIME;

export const decodeFile = (file, decode = () => {}) => {

  const reader = new FileReader();

  reader.onload = (e) => {
      const d = e.target.result;
      decode(d)
  }

  reader.readAsBinaryString(file)
}

const putS3Asset = async (awsKey, { file, onError, onProgress, onSuccess }) => {
  const { name: filename } = file;
  try {
    const data = await uploadS3({
      bucket: AWS_URL.s3.asset.bucket,
      key: `${awsKey}/${getCurrentDateFormat()}/${getCurrentDateTimeFormat()}_${filename}`,
      file,
    })
      .on("httpUploadProgress", ({ loaded, total }) => {
        onProgress(
          {
            percent: Math.round((loaded / total) * 100),
          },
          file
        );
      })
      .done();
    onSuccess(data, file);
  } catch (err) {
    console.error("Error uploading to S3:", err);
    onError(err);
  }
};

export const UploadReceiptAttachment = (data) =>
  putS3Asset(AWS_URL.s3.asset.key.receipt, data);

export const getBase64 = (file, cb = () => {}) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => cb(reader.result));
  reader.readAsDataURL(file);
};
